export const getNumberedLabel = (baseLabel: string, num: number | null) =>
  `${baseLabel}${num !== null ? ` (${num})` : ''}`;
